import { render, staticRenderFns } from "./com_know.vue?vue&type=template&id=f8f1e092&scoped=true&"
import script from "./com_know.vue?vue&type=script&lang=js&"
export * from "./com_know.vue?vue&type=script&lang=js&"
import style0 from "./com_know.vue?vue&type=style&index=0&id=f8f1e092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f1e092",
  null
  
)

export default component.exports